import { Button } from '@creditornot/cb-button';
import { Typography as T } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import HighFiveHands from 'common/illustrations/HighFiveHands';

import { CenteredRoot, Heading, TextStack } from '../ComplianceContent';
import { BREAKPOINT_MOBILE } from '../breakpoints';

const StyledBody = styled(T.Body1)`
  text-align: center;
  max-width: 400px;
`;

const StyledIllustration = styled(HighFiveHands)`
  width: 320px;
`;

const StyledButton = styled(Button)`
  width: 100%;

  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    max-width: 200px;
  }
`;

const KycSuccessThanks = () => {
  const history = useHistory();

  const handleOk = () => {
    history.push('/');
  };

  return (
    <CenteredRoot>
      <StyledIllustration />

      <TextStack>
        <Heading>
          <FormattedMessage id="compliance.kyc.success.heading" />
        </Heading>
        <StyledBody>
          <FormattedMessage id="compliance.kyc.success.body" />
        </StyledBody>
      </TextStack>

      <StyledButton size="large" variant="blue" onClick={handleOk}>
        <FormattedMessage id="compliance.kyc.success.continue" />
      </StyledButton>
    </CenteredRoot>
  );
};

export default KycSuccessThanks;
